import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-contact',
  templateUrl: './home-contact.component.html',
  styleUrls: ['./home-contact.component.sass']
})
export class HomeContactComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
